
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_3_4)"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12zM5.177 9.836L7.46 7.58c.242-.24.57-.376.911-.376H13.994V7.2h1.528c.39 0 .764.16 1.034.441l.045.046.001-.001.443.443.184.184 1.228 1.23.343.343c.503.503.547 1.27.044 1.774l-5.902 5.877c-.524.522-1.37.52-1.892-.002l-.6-.601-1.547-1.547-1.545-1.546-1.546-1.546-.635-.635a1.29 1.29 0 010-1.824z","fill":"#10111D"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_3_4"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h24v24H0z"}})])])])
          )
        }
      }
    